import { useEffect, useState } from 'react';

import { clearRecentEvents, getRecentEvents, onPush } from '../../lib/analytics';

const EVENT_COLORS = {
  scrollEvent: '#64b5f6',
  buttonClick: '#81c784',
};

/**
 * Плавающая панель для отладки событий аналитики (ss-22080).
 * Видна только при включённом флаге debugAnalytics.
 */
export const AnalyticsDebugPanel = () => {
  const [, forceUpdate] = useState(0);

  useEffect(() => onPush(() => forceUpdate((n) => n + 1)), []);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        maxWidth: 480,
        maxHeight: '50vh',
        overflow: 'auto',
        padding: 12,
        borderRadius: 8,
        background: 'rgba(20,20,20,.92)',
        color: '#fff',
        font: '12px/1.4 monospace',
      }}
    >
      <div style={{ marginBottom: 8 }}>
        <b>dataLayer ({getRecentEvents().length})</b>{' '}
        <button onClick={clearRecentEvents}>очистить</button>
      </div>
      {getRecentEvents().map((event, index) => (
        <div key={index} style={{ marginBottom: 6 }}>
          [{event.time}] <b style={{ color: EVENT_COLORS[event.event] }}>{event.event}</b>{' '}
          {event.name}
          {event.eventAction ? ` / ${event.eventAction}` : ''}{' '}
          <span style={{ opacity: 0.6 }}>{event.eventLabel}</span>
        </div>
      ))}
    </div>
  );
};
